const objectiveUtils = {
  dependencyObjectiveComparator: (a, b) => {
    if (a.dependency_objective && !b.dependency_objective) return 1;
    if (!a.dependency_objective && b.dependency_objective) return -1;
    return 0;
  },
  pushDependencyObjectivesAtTheEnd: objectivesList =>
    objectivesList.sort(objectiveUtils.dependencyObjectiveComparator)
};

export const pushDependencyObjectivesAtTheEnd = objectivesList =>
  objectiveUtils.pushDependencyObjectivesAtTheEnd(objectivesList);

export default objectiveUtils;
